import React from 'react';

import { Animation } from 'shared/presentation/components/atoms';
import { useLocale } from 'shared/presentation/contexts';

import loadingAnimation from './assets/loading_gears.json';
import PageWrapper from '../PageWrapper';

const RecognitionLoading: React.FC = () => {
  const { t } = useLocale('shared');

  return (
    <PageWrapper>
      <p>{t('Wait while we prepare the process')}</p>

      <div>
        <Animation
          loop
          animation={{
            data: loadingAnimation,
            height: 180,
            width: 180,
          }}
        />
      </div>
    </PageWrapper>
  );
};

export default RecognitionLoading;
